import { render, staticRenderFns } from "./BioSiqoStep.vue?vue&type=template&id=e621a4f8&scoped=true&"
import script from "./BioSiqoStep.vue?vue&type=script&lang=js&"
export * from "./BioSiqoStep.vue?vue&type=script&lang=js&"
import style0 from "./BioSiqoStep.vue?vue&type=style&index=0&id=e621a4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e621a4f8",
  null
  
)

export default component.exports